import React, {Component} from 'react'
import Logo from '../logo'
// import Search from './Search'
import ToggleLayout1 from './ToggleLayout1'
// import ToggleLayout2 from './ToggleLayout2'
// import ToggleRightSidebar from './ToggleRightSidebar'
// import DropdownGrid from './DropdownGrid'
// import DropdownTasks from './DropdownTasks'
// import DropdownMessages from './DropdownMessages'
import DropdownUser from './DropdownUser'
import DropdownFlags from './DropdownFlags'
import {getSelectedFlagCode, getSubCommunities, setSelectedSubcommunity, getSubCommunityLabel, getSubCommunityNameByLabel, getSubCommunitiesData} from '../../panel-admin/common/functions/countrySetting'
import '../../css/elements/navbar-1.css'
import {clearDashboard} from '../../actions/pages/dashboard-page'
import {connect} from 'react-redux'
import { withRouter } from 'react-router-dom';

class Navbar1 extends Component {
  constructor() {
    super()
    this.state = {
      selectedFlagCode: getSelectedFlagCode(),
      showDropdown:false,
      subcommunityLabel: getSubCommunityLabel()?getSubCommunityLabel():'',
    }
    this.onHandleChange = this.onHandleChange.bind(this)
    this.onShowDropdown = this.onShowDropdown.bind(this)
    this.onChangeSubcommunityLabel = this.onChangeSubcommunityLabel.bind(this)
  }

  onHandleChange() {
    this.setState({
      selectedFlagCode: getSelectedFlagCode()
    })
  }


  onShowDropdown(){
    this.setState({showDropdown:!this.state.showDropdown})
  }

  onChangeSubcommunityLabel(label) {
    this.setState({subcommunityLabel:label })
    let selectedSubcommunity = getSubCommunityNameByLabel(label);

    setSelectedSubcommunity(selectedSubcommunity);
    getSubCommunities();

    this.props.clearDashboard();

    this.props.history.push("/");

    if (this.props.onChange) {
      this.props.onChange();
    }
  }

  render() {
    return (
      <nav className="navbar navbar-1 d-flex justify-content-around align-items-center flex-nowrap">
        <Logo />
        <ToggleLayout1 />
        <div className="separator" />
        {/* <Search /> */}
        <ul className="nav nav-inline nav-inline-2">
          <li className="nav-item nav-item-dropdown">
            <a className="nav-link nav-link-avatar">
              {/* <span className="badge badge-sm badge-rounded badge-warning">1</span> */}
              <i className="material-icons material-icons-3x">account_circle</i>
            </a>
            <DropdownUser />
          </li>
          <li className="nav-item nav-item-dropdown">
            <a className="nav-link" style={{marginTop: '10px'}}>
              <span className={`flag flag-icon-background flag-icon flag-icon-${this.state.selectedFlagCode}`}> </span>
            </a>
              <DropdownFlags onChange={this.onHandleChange} />
          </li>
          {getSubCommunitiesData() &&
            <li className="nav-item nav-item-dropdown" style={getSubCommunitiesData().length>1 ? {marginTop:"10px"} : {marginTop:"18px"}}>
              {getSubCommunities() !== '' && getSubCommunitiesData().length>1 &&
                <>
                  <a className="nav-link">
                    <span style={{fontWeight:"500"}}> {this.state.subcommunityLabel === ''?getSubCommunityLabel():this.state.subcommunityLabel} <i className="ion-arrow-down-b"></i></span>
                  </a>
                  <div className="navbar-dropdown" style={{position:"fixed", marginLeft:"92%", zIndex:"99", width:"120px", top:"90%", cursor:"pointer"}}>
                    <div className="dropdown-inner">
                      {getSubCommunitiesData().map((subCommunity, i) => (
                        <div key={i} className="dropdown-item" onClick={() => this.onChangeSubcommunityLabel(subCommunity.label)} style={{coursor:"pointer"}}>
                            <img src={'/assets/icons/subcommunities/' + subCommunity.name +'.svg'} alt=""  style={{width:"1.33333333em"}} />
                            <span
                              className={`flag flag-icon-background flag-icon flag-icon-${subCommunity.name}`}
                            />
                            <span className="country-name">{subCommunity.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              }
              {getSubCommunities().label  &&
                <span style={{fontWeight:"500"}} onClick={this.onShowDropdown}> {this.state.subcommunityLabel === ''?getSubCommunityLabel():this.state.subcommunityLabel}</span>
              }
          </li>
         }
          {/* <ToggleRightSidebar /> */}
        </ul>
        {/* <ToggleLayout2 /> */}
      </nav>
    )
  }
}

/*
const Navbar1 = () => (
  <nav className="navbar navbar-1 d-flex justify-content-around align-items-center flex-nowrap">
    <Logo />
    <ToggleLayout1 />

    <div className="separator" />

    <ul className="nav nav-inline nav-inline-2">

    </ul>
    <ToggleLayout2 />
  </nav>
)
*/


const mapStateToProps = (state, ownProps) => ({

})
const mapDispatchToProps = dispatch => ({
  clearDashboard() { dispatch(clearDashboard()) }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar1))
